{
  "common" : {
    "customFieldExistsError" : "Custom Field met deze naam bestaat al",
    "uniqueKeyNotUniqueError" : "Deze Key is niet uniek",
    "save" : "Opslaan",
    "saving" : "Opslaan",
    "integrate" : "Integreren",
    "preview" : "Voorbeeldweergave",
    "back" : "Terug",
    "alert" : "Melding",
    "proceed" : "Doorgaan",
    "cancel" : "Annuleren",
    "delete" : "Verwijderen",
    "embed" : "Insluiten",
    "link" : "Link",
    "iframeEmbed" : "Iframe insluiten",
    "styles" : "Stijlen",
    "options" : "Opties",
    "quickAdd" : "Snel toevoegen",
    "customFields" : "Aangepaste velden",
    "personalInfo" : "Persoonlijke gegevens",
    "contactInfo" : "Contactgegevens",
    "submit" : "Verzenden",
    "address" : "Adres",
    "customized" : "Aangepast",
    "layout" : "Lay-out",
    "showLabel" : "Toon label",
    "background" : "Achtergrond",
    "buttonBackground" : "Background Button",
    "fontColour" : "Kleur lettertype",
    "textFontColour" : "Text Font Colour",
    "subTextFontColour" : "Sub Text Font Colour",
    "selectThemes" : "Theme Select",
    "filled" : "Ingevuld",
    "textOnly" : "Alleen Body",
    "border" : "Rand",
    "borderType" : "Randtype",
    "cornerRadius" : "Hoekstraal",
    "width" : "Breedte",
    "padding" : "Opvulling",
    "top" : "Boven",
    "bottom" : "Onder",
    "left" : "Links",
    "right" : "Rechts",
    "center" : "Midden",
    "default" : "Form Default",
    "shadow" : "Schaduw",
    "color" : "Kleur",
    "horizontal" : "Horizontaal",
    "vertical" : "Verticaal",
    "blur" : "Onscherp",
    "spread" : "Verspreiden",
    "fieldStyle" : "Veldstijl",
    "fontColor" : "Kleur lettertype",
    "label" : "Label",
    "fontFamily" : "Lettertypefamilie",
    "size" : "Formaat",
    "weight" : "Dikte",
    "placeholder" : "Plaatshouder",
    "customCSS" : "Aangepaste CSS",
    "backgroundImage" : "Achtergrondafbeelding",
    "headerImage" : "Kopafbeelding",
    "miscellaneous" : "Diversen",
    "agencyBranding" : "Branding van het agentschap",
    "imageUploadMessage" : "Klik of sleep een afbeeldingsbestand naar dit gebied om te uploaden",
    "backgroundImageTooltipMessage" : "De achtergrondafbeelding is bedoeld om de hele pagina te bedekken, om het formulier te voorzien van een visueel aantrekkelijke achtergrond. Klik op de optie Voorbeeld om de achtergrondafbeelding te bekijken.",
    "headerImageTooltipMessage" : "De headerafbeelding is ontworpen om de volledige breedte van het formulier te bedekken en blijft bovenaan het formulier staan. Klik op de optie Voorbeeld om de headerafbeelding te bekijken.",
    "onSubmit" : "Bij verzenden",
    "facebookPixelID" : "Facebook Pixel-ID",
    "facebookPixelIDMessage" : "Negeer dit veld als je dit formulier/deze enquête in een trechter wilt gebruiken",
    "facebookPixelEvents" : "Gebeurtenissen Meta-pixel",
    "onpageView" : "Op paginaweergave",
    "stickyContact" : "Automatisch aangevuld contact",
    "stickyContactMessage" : "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "fieldDescription" : "Beschrijving veld",
    "fieldTitle" : "Titel veld",
    "queryKey" : "Query-ID",
    "querykeyTooltipMessage" : "De querysleutel die als URL-parameter kan worden gebruikt om dit veld aan te vullen",
    "required" : "Vereist",
    "hidden" : "Verborgen",
    "hiddenValue" : "Verborgen waarde",
    "enableCountryPicker" : "Landkeuzelijst inschakelen",
    "altText" : "Alternatieve tekst",
    "alignment" : "Uitlijning",
    "imageWidth" : "Breedte afbeelding",
    "imageHeight" : "Afbeeldingshoogte",
    "logic" : "Logica",
    "pleaseInput" : "Invoeren",
    "editHTML" : "HTML bewerken",
    "textStyle" : "Tekstopmaak",
    "subText" : "Subtekst",
    "text" : "Tekst",
    "buttonStyle" : "Knopstijl",
    "fullWidth" : "Volledige breedte",
    "htmlMessage" : "De aangepaste HTML komt hier te staan",
    "htmlEditorHeader" : "AANGEPAST JAVASCRIPT / HTML",
    "htmlEditorBodyMessage" : "Voeg hier je code toe",
    "yesSave" : "Ja, opslaan",
    "cancelKeep" : "Annuleren, Behouden",
    "done" : "Voltooid",
    "addElement" : "Element toevoegen",
    "addUrlLike" : "Voeg geldige url's toe zoals",
    "doNotAddRelativePath" : "Voeg geen relatieve paden toe zoals",
    "or" : "of",
    "addCustomFields" : "Aangepaste velden toevoegen",
    "customFieldSearch" : "Zoeken op naam",
    "enterSourceValue" : "Voer bronwaarde in",
    "shortLabel" : "Kort label",
    "shortLabelPlaceholder" : "Short Label Type",
    "labelPlaceholder" : "Type een label",
    "fileUploadPlaceholder" : "Een File Upload",
    "customCSSTooltip" : "Aangepaste CSS heeft voorrang op formulieropmaak en thema's en kan een impact hebben op de vormgeving van het thema.",
    "fontFamilyTooltip" : "Builder ondersteunt alle soorten lettertypes als je deze niet in de lijst kunt zien. Zoek in de vervolgkeuzelijst",
    "useGDPRCompliantFont" : "Gebruik AVG-compatibel lettertype",
    "enableTimezone" : "Tijdzone inschakelen",
    "inputStyle" : "Invoerstijl",
    "conditionalLogicAlertOnSubmit" : "Voorwaardelijke logica heeft hier voorrang op het bericht of de doorverwijzing",
    "conditionalLogicAlertOnShowHide" : "Voorwaardelijke logica heeft hier voorrang op de verborgen instellingen",
    "placeholderFacebookPixelIdInput" : "Voer de pixel-ID van Meta in",
    "doNotShowMessage" : "Niet opnieuw tonen",
    "creatingForm" : "Created je Form...",
    "creatingSurvey" : "Heeft je Survey Created ...",
    "creatingQuiz" : "Je quiz Created ...",
    "errorCreatingForm" : "There is een fout Created je Form. Try again.",
    "errorCreatingSurvey" : "There is een fout opgetreden Created je Survey. Try again.",
    "errorCreatingQuiz" : "There is een fout Created . Try again.",
    "redirectMessage" : "You will be redirected to:",
    "themes" : {
      "themes" : "Thema's",
      "alertThemeMessage" : "Door het thema te wijzigen, gaan alle huidige vormgevingsaanpassingen verloren.",
      "useTheme" : "Gebruik thema",
      "removeTheme" : "Thema verwijderen"
    },
    "box" : "Box",
    "line" : "Lijn",
    "message" : "Bericht",
    "openUrl" : "URL openen",
    "borderTypeList" : {
      "dotted" : "Gestippeld",
      "dashed" : "Onderbroken",
      "solid" : "Ononderbroken",
      "none" : "Geen"
    },
    "button" : "Knop",
    "emailNotification" : "E-mailmelding",
    "emailNotificationSubheader" : "Ontvang een e-mail wanneer iemand je formulier invult",
    "subject" : "Onderwerp",
    "emailTo" : "E-mail (Aan)",
    "senderName" : "Naam afzender",
    "senderNameWarning" : "Je (subaccountnaam) wordt toegevoegd als dit leeg blijft",
    "emailError" : "Er is minstens één e-mailadres vereist",
    "emailTooltip" : "Het eerste e-mailadres is bedoeld voor het veld 'Aan'. Alle volgende e-mailadressen worden opgenomen in het veld 'Cc'.",
    "clear" : "Wissen",
    "showNotificationsSettings" : "Meldingsinstellingen tonen",
    "emailServicePaid" : "Deze functie is een betaalde dienst met kosten op basis van je gebruik.",
    "integration" : "Integratie",
    "validation" : {
      "fieldRequired" : "Field is Required",
      "maxLengthExceeded" : "Max. Length overschreden ({max} Character)"
    },
    "payment" : {
      "payments" : "Betalingen",
      "connected" : "Verbonden",
      "connect" : "Verbinden",
      "liveModeOn" : "Live weergave",
      "status" : "Status",
      "test" : "Test",
      "live" : "Live",
      "paymentFields" : "Betalingsvelden",
      "suggestAnAmount" : "Stel een bedrag voor",
      "selectCurrency" : "Valuta selecteren",
      "tagActiveBGColor" : "Actieve tagkleur",
      "includeOtherAmount" : "Voeg een ander bedrag toe",
      "footerInfo" : "Info voettekst",
      "paymentType" : "Betalingstype",
      "sellProducts" : "Producten verkopen",
      "customAmount" : "Aangepast bedrag",
      "collectPayment" : "Betaling innen",
      "generalSettings" : "Algemene velden",
      "securePayments" : "*100% Verkopen & veilig betalen*",
      "error" : {
        "addMainProductFirst" : "Add eerst een PRIMARY Product toe",
        "priceNotFoundForBumpProduct" : "Price niet found voor Bump Product",
        "productAlreadyAdded" : "Product al toegevoegd"
      },
      "product" : {
        "addProduct" : "Product toevoegen",
        "productSettings" : "Productinstellingen",
        "selectProduct" : "Selecteer product",
        "editThisProduct" : "Dit product bewerken",
        "clickHere" : "Klik hier",
        "show" : "Tonen",
        "description" : "Beschrijving",
        "image" : "Afbeelding",
        "layoutSettings" : "Lay-outinstellingen",
        "singleColumn" : "Enkele kolom",
        "twoColumn" : "Twee kolommen",
        "threeColumn" : "Drie kolommen",
        "maxProductError" : "Maximaal 20 producten toegestaan in een formulier",
        "productSelectPlaceholder" : "Selecteer een product",
        "orderConfirmation" : "Bestelbevestiging",
        "orderConfirmationWarning" : "Zodra de betaling is geslaagd, wordt een pagina met de bestelbevestiging getoond",
        "quantity" : "Aantal",
        "createProduct" : "Om een product te maken",
        "noProductsAdded" : "Nog geen producten toegevoegd",
        "productsWillShowHere" : "Zodra You producten Add , worden ze Right here Show",
        "chooseProductType" : "Product Select Type",
        "mainProduct" : "PRIMARY Product"
      },
      "bumProduct" : {
        "price" : "Prijs",
        "variant" : "Variant",
        "headline" : "Koptekst",
        "otoHeadline" : "OTO Headline",
        "otoText" : "OTO Body",
        "enableImage" : "Image Enable",
        "imageMessage" : "We nemen de Default Product",
        "orUploadADifferentImage" : "Of een andere Image Upload",
        "bumpProducts" : "Aanvullende producten",
        "bumpProduct" : "Bump Product",
        "enableBump" : "Bump Enable",
        "orderBumpStyle" : "Order Bump Appearance",
        "classic" : "Klassiek",
        "modern" : "Modern",
        "icon" : "Icon",
        "bumpTemplate" : "Template . Select",
        "highlightText" : "Body Highlight",
        "showPrice" : "Show Price",
        "bumpPriceColor" : "Aanvullende Price",
        "bumpIconColor" : "Bump Icon",
        "bumpBackgroundColor" : "Achtergrond stoten",
        "highlightTextColor" : "Body Highlight",
        "headlineColor" : "Koptekst",
        "otoHeadlineColor" : "OTO Headline",
        "otoTextColor" : "OTO Body",
        "bumpBorderColor" : "Bump Border",
        "priceRequired" : "Price is Required",
        "headlineRequired" : "Headline is Required",
        "bumpProductTooltip" : "Tijdens de Checkout wordt een Small Add-on aangeboden op Multiply Sort Value. Customers kunnen Add met Individual click.",
        "templateOne" : "Sjabloon 1",
        "templateTwo" : "Sjabloon 2",
        "templateThree" : "Sjabloon 3",
        "animationIcon" : {
          "none" : "Geen",
          "arrow" : "Pijltje",
          "fire" : "Brand",
          "plus" : "Plus",
          "giftBox" : "Box",
          "timer" : "Countdown",
          "cracker" : "Cracker",
          "snack" : "Tussendoortje",
          "partyBalloon" : "Feestballon",
          "flash" : "Flash",
          "money" : "Currency",
          "spaceShuttle" : "Room Shuttle"
        }
      },
      "coupons" : {
        "coupons" : "Coupons",
        "enableCoupon" : "Coupon inschakelen",
        "couponAlignment" : "Uitlijning coupons",
        "left" : "Links",
        "right" : "Rechts",
        "fullWidth" : "Volledige breedte",
        "tooltipMessage" : "Stel de positie van de couponinvoer in met de onderstaande types"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Adres automatisch aanvullen",
      "addressfields" : "Adresvelden",
      "placeholderSearch" : "Zoek op adres",
      "autoCompleteTooltip" : "Biedt de mogelijkheid om op adressen te zoeken en deze automatisch aan te vullen. Deze functie is betalend.",
      "streetAddress" : "Straat Address",
      "autoCompleteAddressTitle" : "Finish Auto Address",
      "newBadge" : "new",
      "defaultLabel" : "Adres",
      "searchPlaceholder" : "Search Address",
      "mandataorySearch" : {
        "title" : "Required to Select Address in Bar",
        "primaryText" : "Alleen automatisch aanvullen voor Address",
        "secondaryText" : "When When Operator het Address Field Enabled , moet Then een geldig Address to Continue Select .",
        "secondaryText1" : "When kunnen ze Continue zonder een Address Disabled selecteren in de Search ."
      }
    },
    "autoResponder" : "Automatische beantwoorder",
    "autoResponderSubheader" : "Verzend een automatische e-mail naar de persoon die het formulier heeft ingediend (de e-mail bevat een kopie van de informatie die op het formulier werd ingevuld)",
    "replyToEmail" : "Antwoord op e-mail",
    "open" : "Open",
    "won" : "Gewonnen",
    "lost" : "Verloren",
    "abandon" : "Verlaten",
    "selectAPipeline" : "Selecteer een pijplijn",
    "stage" : "Stadium",
    "status" : "Status",
    "opportunityValue" : "Waarde opportuniteit",
    "createNewPipeline" : "Maak een pijplijn aan",
    "editOpportunitySettings" : "Instellingen opportuniteit bewerken",
    "contact" : "Contactpersoon",
    "opportunity" : "Opportuniteit",
    "add" : "Toevoegen",
    "more" : "Meer",
    "opportunityHeading" : "Waar wilt u uw opportuniteit bijwerken?",
    "date" : {
      "dateSettings" : "Datuminstellingen",
      "dateFormat" : "Datumformaat",
      "dateSeparator" : "Scheidingsteken datum",
      "dateFormatTooltipMessage" : "Selecteer een datumnotatie. D staat voor dag, M voor maand en J voor jaar",
      "dateSeparatorTooltipMessage" : "Selecteer een scheidingsteken dat de dag, maand en het jaar scheidt in de indeling die je hebt geselecteerd voor Datumnotatie",
      "disablePicker" : "Picker uitschakelen"
    },
    "restoreVersion" : "Herstel versie",
    "versionHistory" : "Versiegeschiedenis",
    "errorMessage" : "Fout, probeer het opnieuw",
    "version" : "Versie:",
    "currentVersion" : "Huidige versie",
    "messageStyling" : "Berichtopmaak",
    "validateEmailHeader" : "E-mail valideren",
    "validateEmailDescription" : "De knop wordt getoond zodra de gebruiker een e-mailadres invoert. Deze functie is ontworpen om kwalitatieve leads te genereren.",
    "validatePhoneHeader" : "Telefoonnummer valideren",
    "validatePhoneDescription" : "De knop wordt getoond zodra de gebruiker een telefoonnummer invoert. Deze functie is ontworpen om kwalitatieve leads te genereren.",
    "validatePhoneWarning" : "Om SMS OTP-verificatie in te schakelen, moet je telefoonnummer zijn ingesteld in je locatie-instellingen",
    "addAnotherTnc" : "Add another T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Type DELETE to confirm",
    "style" : {
      "formLayoutType" : "Formuliertype",
      "layoutType" : "Layout Type",
      "surveyType" : "Survey Type",
      "oneColumn" : "Eén kolom",
      "twoColumn" : "Twee kolommen",
      "singleLine" : "Enkele lijn",
      "fieldWidth" : "Breedte veld",
      "labelAlignment" : {
        "labelAlignment" : "Uitlijning label",
        "labelWidth" : "Breedte label"
      },
      "fieldSpacing" : "Afstand tussen velden",
      "color" : "kleur",
      "fontColor" : "Kleur lettertype",
      "inputBackground" : "Achtergrond invoer",
      "layout" : "Layout",
      "colorsAndBackground" : "Kleuren en achtergrond",
      "advanceSettings" : "Geavanceerde Settings",
      "inputField" : "Invoerveld",
      "borderWidth" : "Randbreedte",
      "borderColor" : "Randkleur",
      "borderStyle" : "Randstijl",
      "fontSize" : "Lettergrootte",
      "fontWeight" : "Lettergewicht",
      "labelColor" : "Labelkleur",
      "placeholderColor" : "Kleur placeholder",
      "shortLabelColor" : "Korte labelkleur"
    },
    "replyToTooltip" : "Pas het standaard e-mailadres voor antwoorden aan door {'{'}{'{'}contact.email{'}'}{'}'} te gebruiken om antwoorden te activeren voor de contactpersoon die het formulier indient.",
    "content" : "Content",
    "calculations" : "Berekeningen",
    "uploadOptions" : "Uploadopties",
    "opportunitySettingsWarning" : "Stel de opportuniteitsinstellingen in door op de knop Opportuniteitsinstellingen bewerken te klikken.",
    "question" : "Vraag",
    "createContactOnPartialSubmission" : "Contact aanmaken bij gedeeltelijke indiening",
    "howItWorks" : "Hoe werkt het?",
    "createContactOnPartialSubmissionDescription" : "Rond de slide af en klik op 'Volgende'. Er wordt automatisch een nieuw contact aangemaakt en opgeslagen.",
    "swapWarningMessageSurvey" : "Het bewerken of verwisselen van opties heeft invloed op dit aangepaste veld op alle plaatsen waar het wordt gebruikt. Het kan ook de voorwaardelijke logica resetten. ",
    "swapWarningMessageForm" : "Het bewerken of verwisselen van opties heeft invloed op dit aangepaste veld op alle plaatsen waar het wordt gebruikt. ",
    "migrationWarningMessage" : "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel" : "Optielabel",
    "calculationValue" : "Waarde berekening",
    "addOption" : "Optie toevoegen",
    "enableCalculations" : "Berekeningen inschakelen",
    "allowOtherOption" : "Allow Other Option",
    "productSelectionSubtext" : "Of Individual Product selecteren",
    "multi" : "Multi",
    "single" : "Individual",
    "productSelectionHeading" : "Product",
    "spreadToColumns" : "Verspreiden naar kolommen",
    "columns" : "Kolommen",
    "integratePopup" : {
      "embedCode" : "Embed Code",
      "useInFunnelOrEmbedCode" : "Use in Funnel/ Embed Code",
      "iframeEmbed" : "Iframe Embed",
      "funnel" : {
        "funnel" : "Trechter",
        "chooseStep" : "Select a Step",
        "copyCodeAndOpenFunnel" : "Copy Code & Open Funnel"
      },
      "share" : {
        "share" : "Share",
        "shareViaSocials" : "Share Via Socials",
        "copyLink" : "Link kopiëren"
      },
      "email" : {
        "email" : "E-mail",
        "shareViaEmail" : "Via Email Share",
        "emailButton" : "E-mail",
        "blankTemplate" : "Template Template",
        "emailMarketingTemplates" : "Sjablonen voor Email Marketing",
        "or" : "Of",
        "chooseTemplate" : "Choose from your templates",
        "continue" : "Doorgaan"
      }
    },
    "rating" : {
      "icon" : "Icon",
      "iconAlignment" : "Icon Alignment",
      "count" : "Count",
      "lowestRating" : "Min beoordeling",
      "highestRating" : "Max. beoordeling",
      "iconSelectedState" : "Icon Selected State",
      "iconUnselectedState" : "Icon Niet geselecteerde State",
      "rating" : "Beoordeling",
      "ratingSettings" : "Rating Settings",
      "calculationType" : {
        "calculationType" : "Archive voor Rating Fields in Custom Fields",
        "calculationTypeTooltip" : "When You Frequency iets 4 From 5 sterren, betekent dit: - Absoluut: 4 From 5 - Percentage: 80 - Fractie: 0,8",
        "absolute" : "Absoluut",
        "percentage" : "Percentage",
        "fraction" : "Fractie"
      }
    },
    "desktopMode" : "Weergave desktop",
    "mobileMode" : "Weergave mobiel",
    "versions" : "Variants",
    "advanced" : "Advanced",
    "edit" : "Edit",
    "settings" : "Settings",
    "submissions" : "Submissions",
    "undo" : "Undo",
    "redo" : "Redo",
    "customValues" : "Aangepaste waarden",
    "pickBgFromImage" : "Selecteer een achtergrondkleur van de achtergrondafbeelding van het Formulier.",
    "pickBgFromImageTip" : "Kies een Kleur met hoog Vergelijken voor de BG-Afbeelding. Bericht: Wordt niet toegepast als de Achtergrond van het Formulier geen Afbeelding heeft",
    "messageBackgroundBlur" : "Achtergrond onscherp maken voor berichten",
    "confirmationMessage" : "Confirmation Message",
    "deleteOption" : "Removing Option",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Het verwijderen van een optie heeft invloed op dit Aan Field voor every Seats waar het Field wordt gebruikt. Weet You zeker dat You het wilt Removing ?",
      "validationMessage" : "Voer in Removing to Saving.",
      "validationError" : "Voer in Removing"
    },
    "disqualifyImmediately" : "Disqualify Immediately",
    "disqualifyAfterSubmit" : "Disqualify After Submit",
    "generalSettings" : "General Settings",
    "advancedSettings" : "Geavanceerde Settings",
    "customFieldName" : "Custom Industry Name",
    "customFieldNameTooltip" : "Deze Industry is uniek per Custom Industry.",
    "uniqueKey" : "Unieke sleutel",
    "uniqueKeyTooltip" : "Deze Key is uniek per Custom Industry.",
    "survey" : {
      "layoutType" : "Survey Type",
      "oneQuestionPerPage" : "One Question at a Time",
      "allQuestionsOnePage" : "Many at a Time"
    },
    "quizQuestions" : "Quiz Question",
    "choiceElements" : "Choice Components",
    "otherElements" : "Other Components",
    "listEditor" : {
      "prefillValueHeader" : "Prefill Value",
      "labelPlaceholder" : "Label",
      "valuePlaceholder" : "Waarde",
      "optionRequiredError" : "De optie Field is Required"
    },
    "field" : "Veld",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Add Field",
      "fieldLabel" : "Veld",
      "numberLabel" : "number"
    },
    "fileUploadEditor" : {
      "fileTypes" : "File",
      "all" : "every",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "Oké",
    "select" : "Selecteren",
    "allowMultipleFiles" : "Meerdere Files Enable",
    "maxFileLimit" : "Max File",
    "privacyPolicy" : "Privacybeleid",
    "termsOfService" : "of"
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Individual keuze",
      "multipleChoice" : "Meerkeuze",
      "yesNo" : "Ja / Nee",
      "shortAnswer" : "Short Response",
      "longAnswer" : "Long Response",
      "number" : "number",
      "singleDropdown" : "Dropdown Individual",
      "multiDropdown" : "Multi- Dropdown"
    },
    "personal" : {
      "fullName" : "Full Name",
      "firstName" : "Voornaam",
      "lastName" : "last Name",
      "dateOfBirth" : "Date",
      "phone" : "Telefoon",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Knop"
    },
    "integration" : {
      "sellProducts" : "Producten verkopen",
      "collectPayment" : "Uitbetaling innen"
    },
    "address" : {
      "address" : "Adres",
      "streetAddress" : "Straat Address",
      "city" : "Stad",
      "state" : "Staat",
      "country" : "Land",
      "postalCode" : "Code",
      "organization" : "Group",
      "website" : "Website",
      "websitePlaceholder" : "De web URL gaat here"
    },
    "text" : {
      "singleLine" : "Line Individual",
      "multiLine" : "Multi Line",
      "textBoxList" : "List Square Square"
    },
    "choiceElements" : {
      "singleDropdown" : "Dropdown Individual",
      "multiDropdown" : "Multi- Dropdown",
      "checkbox" : "Selectievakje",
      "radio" : "Radio"
    },
    "customized" : {
      "text" : "Klik om deze tekst te bewerken",
      "html" : "HTML",
      "htmlPlaceholder" : "De Custom HTML komt here te staan",
      "captcha" : "Captcha",
      "source" : "Bron",
      "termsAndConditions" : "T & C",
      "termsAndConditionsPlaceholder" : "Ik ga akkoord met de voorwaarden Issued Via het bedrijf. Via mijn Phone Number te verstrekken, ga ik akkoord met Inherit Tekst berichten From the business.",
      "score" : "Score"
    },
    "other" : {
      "image" : "Afbeelding",
      "fileUpload" : "Upload File",
      "monetary" : "Monetair",
      "number" : "number",
      "datePicker" : "Date",
      "signature" : "Handtekening"
    }
  },
  "survey" : {
    "typeOfBuilder" : "Enquête",
    "survyeStyle" : "Enquetestijl",
    "surveyName" : "Enquêtenaam",
    "surveyElement" : "Enquête-element",
    "addSurveyElement" : "Enquête-element toevoegen",
    "unsavedAlertMessage" : "De enquête bevat niet-opgeslagen werk. Weet je zeker dat je al het niet-opgeslagen werk wilt wissen?",
    "thirdPartyScriptAlertMessage" : "In het HTML-blok kunnen scripts van derden krachtige functionaliteit bieden, maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en paginagedrag. Daarom raden we je aan de inhoud van dit script te bekijken voordat je het opslaat in de enquête.",
    "integrateHeader" : "Enquête integreren",
    "integrateSubHeader" : "Gebruik de volgende opties om je aangepaste enquête in je website te integreren",
    "integrateCopyLinkMessage" : "Kopieer onderstaande link om deze te delen.",
    "onSurveySubmission" : "Bij het indienen van een enquête",
    "surveySettings" : "Instellingen voor enquêtes",
    "oneQuestionAtTime" : "Eén vraag tegelijk",
    "backButton" : "Terugknop",
    "backButtonTooltipMessage" : "Back button will help users to move to the previous slide",
    "disableAutoNavigation" : "Automatische navigatie uitschakelen",
    "disableAutoNavigationTooltipMessage" : "Navigeert automatisch naar de Next Slide After a Operator reageert.",
    "autoNavigation" : "Auto navigatie",
    "autoNavigationTooltipMessage" : "Navigeert automatisch naar de Next Slide After a Operator reageert.",
    "progressBar" : "Voortgangsbalk",
    "progressBarTooltipMessage" : "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation" : "Animatie uitschakelen",
    "disableAnimationTooltipMessage" : "Door dit in te schakelen, wordt de animatie bij de slideovergang uitgeschakeld",
    "scrollToTop" : "Scroll naar boven",
    "scrollToTopTooltipMessage" : "Door deze optie in te schakelen, wordt de enquête op de volgende slide naar boven gescrold",
    "footerHTML" : "HTML-voettekst",
    "footerHTMLMessage" : "Je kunt aangepaste CSS (met behulp van style tag) en HTML in hetzelfde vak schrijven",
    "editFooter" : "Voettekst bewerken",
    "disqualifySettings" : "Disqualify Settings",
    "disqualifyImmediately" : "Onmiddellijk diskwalificeren",
    "disqualifyAfterSubmit" : "Diskwalificeren na indiening",
    "disqualifyImmediatelyLabel" : "Immediately",
    "disqualifyAfterSubmitLabel" : "After Submit",
    "slideConflictAlertMessage" : "Deze dia bevat meerdere vragen waarvoor een logica is ingesteld. Dit kan onbedoeld gedrag veroorzaken",
    "addSlide" : "Slide toevoegen",
    "settings" : "Instellingen",
    "delete" : "Verwijderen",
    "slideDeleteAlertMessage" : "Weet je zeker dat je deze dia wilt verwijderen?",
    "slideDeleteBetweenAlertMessage" : "Hiermee worden de andere slides opnieuw gerangschikt. Weet je zeker dat je deze slide wilt verwijderen?",
    "slideLabel" : "Slide {n}",
    "slideName" : "Naam slide",
    "slidePosition" : "Positie slide",
    "jumpTo" : "Ga naar",
    "jumpToSubText" : "Jump to a specific slide",
    "enableTimezoneSurvey" : "Door deze optie te activeren, worden de gegevens van de tijdzone van de persoon die de enquête indient geregistreerd.",
    "footer" : {
      "footer" : "Voettekst",
      "enableNewFooter" : "Nieuwe voettekst inschakelen",
      "stickToSurvey" : " Blijf bij de enquête",
      "backgroundFill" : "Achtergrondvulling",
      "footerHeight" : "Hoogte voettekst",
      "enableProgressBar" : "Voortgangsbalk inschakelen",
      "buttons" : "Knop",
      "button" : "Knop",
      "buttonType" : "Type knop",
      "fillNext" : "Invullen (volgende)",
      "fillPrevious" : "Invullen (vorige)",
      "fillSubmit" : "Invullen (indienen)",
      "textColor" : "Knoptekst",
      "position" : "Positie",
      "previousText" : "Vorige (tekst)",
      "nextText" : "Volgende (tekst)",
      "submitText" : "Indienen (tekst)",
      "fillComplete" : "Invullen voltooid",
      "fillInactive" : "Invullen inactief",
      "footerType" : "Voetteksttype",
      "stickToCard" : "Op kaart plakken",
      "stickToPage" : "Op pagina plakken",
      "stepTextColor" : "Body kleur Step",
      "progressBarFill" : "Progress bar Fill",
      "progressBarInactive" : "Voortgangsbalk Inactief",
      "arrowFill" : "Fill Arrow",
      "submitColorMobile" : "Verzenden (Color)",
      "arrowFillColor" : "Arrow Fill Color"
    },
    "surveyNotfication" : "Enquêtemelding",
    "style" : {
      "surveyPadding" : "Enquête-opvulling"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Survey",
      "share" : {
        "openFormLink" : "Linknaar Survey Open"
      },
      "email" : {
        "emailSubheader" : "Create een Embed e - Email en Embed uw Survey aan ."
      }
    },
    "autoResponderSubheader" : "Verzend een automatische e-mail naar de persoon die de enquête indient (de e-mail bevat een kopie van de informatie die in de enquête werd ingevuld)",
    "switchToOneQuestionAtTimeOn" : "Het inschakelen van 'Eén Question op a Date' verstoort je Current voorwaardelijke Logic",
    "switchToOneQuestionAtTimeOff" : "'One Question at a Date ' Disable invloed op je voorwaardelijke Logic Config",
    "switchToOneQuestionAtTimeOnWarning" : "Sommige voorwaarden werken niet meer zoals verwacht When vragen zijn Showed op een Date.",
    "switchToOneQuestionAtTimeOffWarning" : " Sommige voorwaarden voor Persoon- Question Flow werken niet meer zoals bedoeld.",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey."
  },
  "form" : {
    "typeOfBuilder" : "Formulier",
    "formStyle" : "Stijl formulier",
    "formElement" : "Formulierelement",
    "addFormElement" : "Formulierelement toevoegen",
    "addConditionalLogic" : "Voorwaardelijke logica toevoegen",
    "openConditionalLogic" : "Open Conditional Logic",
    "inlineForm" : "Inline-formulier",
    "formName" : "Naam formulier",
    "fullScreenMode" : "Modus volledig scherm",
    "fullScreenModetooltip" : "Door dit in te schakelen, breidt het formulier zich uit over de gehele breedte van de container, tot aan de rand van het inbeddingsgebied terwijl de breedte van het formulier blijft behouden.",
    "enableTimezoneForm" : "Door deze optie te activeren, worden de gegevens van de tijdzone van de persoon die het formulier indient geregistreerd.",
    "formSettings" : "Formulierinstellingen",
    "unsavedAlertMessage" : "Het formulier heeft niet-opgeslagen werk. Weet je zeker dat je al het niet-opgeslagen werk wilt wissen?",
    "thirdPartyScriptAlertMessage" : "In het HTML-blok kunnen scripts van derden krachtige functionaliteit bieden, maar brengen ook risico's met zich mee op het gebied van privacy, beveiliging, prestaties en paginagedrag. Daarom raden we je aan om de inhoud van dit script te bekijken voordat je het opslaat in het formulier.",
    "onFormSubmission" : "Bij het indienen van een formulier",
    "integrateForm" : "Formulier integreren",
    "embedlayoutType" : "Embed Layout Type",
    "embedlayoutTypeSubMessage" : "Selecteer een lay-out om in te sluiten in een trechter of een externe website",
    "triggerType" : "Triggertype",
    "showOnScrolling" : "Weergeven tijdens het scrollen",
    "showAfter" : "Weergeven na",
    "seconds" : "seconden",
    "alwaysShow" : "Altijd weergeven",
    "activationOptions" : "Activatieopties",
    "activateOn" : "Activeren op",
    "visit" : "bezoeken",
    "alwaysActivated" : "Altijd ingeschakeld",
    "deactivationOptions" : "Deactivatieopties",
    "deactivateAfterShowing" : "Uitschakelen na weergave",
    "times" : "keer",
    "deactiveOnceLeadCollected" : "Deactiveer zodra de lead is verzameld",
    "neverDeactivate" : "Nooit uitschakelen",
    "copyEmbedCode" : "Insluitcode kopiëren",
    "copyFormLink" : "Link naar formulier kopiëren",
    "openFormLink" : "Link naar formulier openen",
    "inline" : "Inline",
    "inlineDescription" : "Een inlineformulier wordt samen met de inhoud van de pagina als een native element getoond. Het is geen overlay en kan niet worden gesloten of geminimaliseerd.",
    "inlineHoverDescription" : "Een inlineformulier wordt samen met de inhoud van de pagina als een native element getoond. Het is geen overlay en kan niet worden gesloten of geminimaliseerd.",
    "popup" : "Pop-up",
    "popupDescription" : "Een pop-up toont het formulier als een overlay in een lichtbak. Het kan niet geminimaliseerd maar wel gesloten worden.",
    "popupHoverDescription" : "Een pop-up toont het formulier als een overlay in een lichtbak. Het kan niet geminimaliseerd maar wel gesloten worden.",
    "politeSlideIn" : "Discrete slide-in",
    "politeSlideInDescription" : "Onderaan het scherm verschijnt een discrete slide-in die verdwijnt wanneer het scherm wordt gesloten",
    "politeSlideInHoverDescription" : "Verschijnt onderaan het scherm en verdwijnt wanneer het scherm wordt gesloten",
    "stickySidebar" : "Vastgezette zijbalk",
    "stickySidebarDescription" : "Aan de zijkant van het scherm verschijnt een vastgezette sidebar die kan worden geminimaliseerd tot een tabblad dat aan de zijkant van het venster blijft plakken.",
    "stickySidebarHoverDescription" : "Verschijnt aan de zijkant van het scherm en kan worden geminimaliseerd tot een tabblad dat aan de zijkant van het venster blijft plakken",
    "allowMinimize" : "Minimaliseren toestaan",
    "conditonalLogic" : {
      "conditions" : "Voorwaarden",
      "noExistingCondition" : "Nog geen bestaande voorwaarden",
      "freeRoamMessage" : "Je hebt de volledige vrijheid zonder regels - althans voorlopig",
      "addNewCondition" : "Nieuwe conditie toevoegen",
      "redirectToUrl" : "Doorverwijzen naar url",
      "displayCustomMessage" : "Aangepast bericht weergeven",
      "disqualifyLead" : "Lead diskwalificeren",
      "showHideFields" : "Velden tonen/verbergen",
      "jumpTo" : "Jump To",
      "redirectToUrlSubText" : "Operator omleiding na indiening",
      "displayCustomMessageSubText" : "Show berichten op basis On Operator",
      "disqualifyLeadSubText" : "Items onder specifieke voorwaarden eruit Filter",
      "showHideFieldsSubText" : "Field Visibility Modify",
      "openBelowUrl" : "Open de onderstaande URL",
      "showCustomMessage" : "Aangepast bericht weergeven",
      "alertConditionDelete" : "Weet je zeker dat je deze voorwaarde wilt verwijderen?",
      "deleteCondition" : "Voorwaarde verwijderen",
      "conditionExecutedMessage" : "Voorwaarden worden van boven naar beneden uitgevoerd.",
      "allOperationOptions" : {
        "isEqualTo" : "Is gelijk aan",
        "isNotEqualTo" : "Is niet gelijk aan",
        "contains" : "Bevat",
        "startsWith" : "Begint met",
        "endsWith" : "Eindigt met",
        "isEmpty" : "Is leeg",
        "isFilled" : "Is ingevuld",
        "before" : "Voor",
        "after" : "Na",
        "greaterThan" : "Groter dan",
        "lessThan" : "Lager dan"
      },
      "logic" : {
        "if" : "Als",
        "then" : "Dan",
        "and" : "En",
        "or" : "Of"
      },
      "phoneAlertMessage" : "Om te zoeken op telefoonnummers met een landcode, moet je expliciet het '+'-symbool opnemen in je zoekopdracht.",
      "deleteAlertMessage" : "Weet je zeker dat je dit veld wilt verwijderen? De voorwaarde die aan dit veld is gekoppeld, wordt dan ook verwijderd.",
      "deleteField" : "Veld verwijderen",
      "jumpToDescription" : "Jump to a specific slide when conditions are met",
      "jumpToSlide" : "Jump To Slide",
      "selectSlideToJumpTo" : "Select slide to jump to",
      "selectedSlide" : "Selected slide"
    },
    "minimizedTitlePlaceholder" : "Geminimaliseerde titel",
    "dragYourElementFromLeft" : "Sleep je elementen naar hier vanaf links",
    "formNotification" : "Formuliermelding",
    "style" : {
      "formPadding" : "Formulieropvulling"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Form",
      "share" : {
        "openFormLink" : "Form LinkOpen"
      },
      "email" : {
        "emailSubheader" : "Create een lege Email en Embed uw Form, of Select een Template en Embed it Immediately."
      }
    },
    "choosePosition" : "Status Select"
  },
  "quiz" : {
    "quizElement" : "Quiz-element",
    "quizNotification" : "Quizmelding",
    "viewAndCustomise" : "Bekijken en aanpassen",
    "categoryAndScore" : "Categorie en score",
    "provideFeedback" : "Feedback geven",
    "addQuizElement" : "Quiz-element toevoegen",
    "typeOfBuilder" : "Quiz",
    "addQuestions" : "Vragen Add",
    "dragAndDropQuestion" : "Drag and drop a Question Element here.",
    "addNewPage" : "Add new Page",
    "editTemplate" : "Template Edit",
    "category" : {
      "category" : "Categorie",
      "watchVideo" : "View deze Video voor meer informatie About de invloed van Category op de resultaten Page!",
      "useCategoryWhen" : "Categories When gebruiken",
      "manageCategories" : "Manage Categories",
      "howItWorks" : "Hoe werkt dit",
      "howItWorks2" : "Hoe werkt dit?",
      "addCategoryMessage" : "Een new Category Add",
      "assignCategoryMessage" : "Wijs een Category toe aan every optie",
      "editResultsMessage" : "Category Page 'Show in",
      "addCategory" : "Add Category",
      "deleteCategoryAlertMessage" : "Het verwijderen van een Category heeft Result tot de rest of die Category in every Options",
      "editOrAddNewCategories" : "You Categories new Add Edit",
      "toEvaluateTheResponder" : "Om verschillende factoren op basis On antwoorden met Compare",
      "showMultipleCategoryScore" : "Show meerdere Category score in Result Page",
      "displayVaryingContent" : "Display wisselende Content On de resultaten Page afhankelijk On de scorecategorie van de Category",
      "theOptionFieldIsRequired" : "The option field is required",
      "addManage" : "Add / Manage"
    },
    "quizSettings" : "Quiz-instellingen",
    "onQuizSubmission" : "Over het indienen van de quiz",
    "settings" : "Instellingen",
    "deletePage" : "Pagina verwijderen",
    "quizResult" : {
      "resultTemplate" : "Sjabloon voor resultaten",
      "quizResultAlertMessage" : "De gekozen resultatenpagina wordt weergegeven zodra de quiz is voltooid"
    },
    "autoResponderSubheader" : "Verzend een automatische e-mail naar de persoon die de quiz heeft ingediend (de e-mail bevat een kopie van de informatie die bij de quiz werd ingevuld)",
    "integrateHeader" : "Quiz integreren",
    "integrateSubHeader" : "Gebruik de volgende opties om je aangepaste quiz in je website te integreren",
    "integrateCopyLinkMessage" : "Kopieer onderstaande link om deze te delen.",
    "pageLabel" : "Page {n}",
    "pageName" : "Paginanaam",
    "pagePosition" : "Paginapositie",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Quiz",
      "share" : {
        "openFormLink" : "Linknaar quiz Open"
      },
      "email" : {
        "emailSubheader" : "Create een blanco Email en Embed uw quiz, Of Select een Template en Embed it Immediately."
      }
    }
  }
}
